import api from '@/api/API';
import { QueryFilters, QueryResult } from '@/types';

export default {
  findAll(filters: QueryFilters): Promise<QueryResult> {
    return api
      .get('price-plans', { params: filters })
      .then(response => response.data);
  },
};
